import { render, staticRenderFns } from "./FormCaptcha.vue?vue&type=template&id=6dca90b6&scoped=true&"
import script from "./FormCaptcha.vue?vue&type=script&lang=js&"
export * from "./FormCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dca90b6",
  null
  
)

export default component.exports